import getCreateAttachmentHandlerForLocalFile from './getCreateAttachmentHandlerForLocalFile';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import strings from 'owa-strings/owa-mail-strings';
var attachmentMultiMenuEntry = {
    computer: {
        text: function () { return strings.computerMenuText; },
        iconProps: {
            iconName: "System" /* System */,
        },
        getCreateAttachmentHandler: getCreateAttachmentHandlerForLocalFile,
        logUsage: function (entrySource) {
            var _a = datapoints.FPDualEntryComputer.datapoint, eventName = _a.name, customData = _a.customData;
            logUsage(eventName, customData(entrySource.toString()));
        },
    },
    onlineLocation: {
        text: function () { return strings.cloudLocationsMenuText; },
        iconProps: {
            iconName: "Cloud" /* Cloud */,
        },
        getCreateAttachmentHandler: function (_, createAttachment) { return createAttachment; },
        logUsage: function (entrySource) {
            var _a = datapoints.FPDualEntryFilePicker.datapoint, eventName = _a.name, customData = _a.customData;
            logUsage(eventName, customData(entrySource.toString()));
        },
    },
};
export default attachmentMultiMenuEntry;
//# sourceMappingURL=attachmentMultiMenuEntry.js.map